import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Lobby from '../pages/lobby/Lobby';
import Friends from '../pages/friends/Friends';
import Register from '../pages/register/Register';
import Welcome from '../pages/welcome/Welcome';
import MyHub from '../pages/MyHub/MyHub';
import Table from '../pages/table/Table';
import ROUTES from './Routes';
import Modals from '../pages/modals/Modals';
import AuthGuard from '@/features/auth/components/AuthGuard';
import RegisteredGuard from '@/features/auth/components/RegisteredGuard';
import KycGuard from '@/features/auth/components/KycGuard';
import Auth from '../pages/auth/Auth';
import KycSumsub from '../pages/kyc/KycSumsub';
import Replay from '@/pages/replay/Replay';
import FriendsRequest from '../pages/friendsRequest/FriendsRequest';
import Avaturn from '../pages/avaturn/Avaturn';

export const AppRouter = () => {
  /**
   * Consider different auth guard levels:
   * - PrivyAuthentication -> if not Navigates to Login
   * - UserRegistration -> if not Navigates to Register
   * - KYCComplete (Deepest Level Auth) -> if not Navigates to KYC
   */
  return (
    <Router>
      <Modals />
      <Routes>
        <Route element={<AuthGuard />}>
          <Route element={<RegisteredGuard />}>
            <Route element={<KycGuard />}>
              <Route path={ROUTES.TABLE} element={<Table />} />
              <Route path={ROUTES.REPLAY} element={<Replay />} />
              <Route path={ROUTES.LOBBY} element={<Lobby />} />
              <Route path={ROUTES.FRIENDS} element={<Friends />} />
              <Route path={ROUTES.FRIENDS_REQUEST} element={<FriendsRequest />} />
              <Route path={ROUTES.WELCOME} element={<Welcome />} />
              <Route path={ROUTES.MY_HUB} element={<MyHub />} />
              <Route path={ROUTES.DEFAULT} element={<Lobby />} />
              <Route path={ROUTES.AVATURN} element={<Avaturn />} />
            </Route>
            <Route path={ROUTES.KYC} element={<KycSumsub />} />
          </Route>
          <Route path={ROUTES.REGISTER} element={<Register />} />
        </Route>
        <Route path={ROUTES.LOGIN} element={<Auth />} />
      </Routes>
    </Router>
  );
};
